import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import ReportSummaryBoard from '../components/molecules/ReportSummaryBoard';
import GrowthTrendBoard from '../components/molecules/GrowthTrendBoard';
import DistributionBoard from '../components/molecules/DistributionBoard';
import Text from '../components/atoms/Text';
import { tutorialPageKeys } from '../data/tutorialConfig';
import { useTutorial } from '../hooks/useTutorial';
import { tutorialImages } from '../data/tutorialImages';
import TutorialOverlay from '../components/molecules/auth/TutorialOverlay';
import { getReport } from '../api/report';
import { useEffect, useState } from 'react';
import { logEvent } from '../utils/eventLogger';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from '../components/molecules/common/LoadingOverlay';

const Wrapper = styled.div`
  width: 100%;
  padding: 20px;
  text-align: left;
`
const Today = styled(Text)`
  display: inline-block;
  margin-bottom: 12px;
`

const Report = () => {
   // 튜토리얼 훅
  const page = tutorialPageKeys.REPORT;
  const { show, complete } = useTutorial(page);
  const datas = tutorialImages.REPORT.steps;
  
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchReport = async() => {
      try {
        const rlt = await getReport();
        // console.log('report: ', rlt)
        
        if (!rlt || rlt.hrMapping === false) {
          alert("대화 스크립트에서 단어를 등록해 주세요.\n등록된 단어를 바탕으로 리포트가 생성됩니다.");
          navigate(-1); 
          return;
        }

        setReport(rlt)
        // 로그 기록
        logEvent("report_view", { reportType: "default" });

      } catch (err) {
        // console.log(err)
        console.error(err);
      } finally {
        setIsLoading(false)
      }
    }
    fetchReport()
  }, [])

  const formatDate = (utcString) => {
    const date = new Date(utcString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // if (!report) return null;

  return (
    <DefaultLayout
      headerType="main"
      title="분석리포트"
      hasNavBar={true}
      bgColor="gray">
      <Wrapper>
        {isLoading ? (
          // <div>로딩 중...</div>
          // <LoadingOverlay/>
          <></>
        ) : (
          <>
            {report && <Today variant="body2" color="alternative">{report.currentDate}</Today>}
            {report && <ReportSummaryBoard data={report.summary}/>}
            {report && <GrowthTrendBoard data={report.trends}/>}
            {report && <DistributionBoard data={report.distribution}/>}
          </>
        )}
      </Wrapper>
      {show && <TutorialOverlay datas={datas} onClose={complete} />} 
    </DefaultLayout>
  )
}

export default Report
